module.exports = __webpack_public_path__ + "media/images/default/pages/about/main/33821-2882ab7b06183f7e8282b97e7384a3c9.svg";